module.exports = __webpack_public_path__ + "static/media/digi-key.c446bd19.jpg";